import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnInit,
    ViewEncapsulation,
    DestroyRef} from '@angular/core';
import {Router} from '@angular/router';
import {BooleanInput} from '@angular/cdk/coercion';
import {takeUntil} from 'rxjs';
import {UserService} from '../../../../../../../apps/fuse/src/app/core/user/user.service';
import {UserResource} from 'libs/kfp/src';
import {AuthService} from "../../../auth/auth.service";
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user',
    standalone: false
})
export class UserComponent implements OnInit {
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */
    @Input() showAvatar = true;
    user?: UserResource;
    /**
     * Constructor
     */
    constructor(private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        private _authService: AuthService, private readonly destroyRef: DestroyRef) {
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    /**
     * On init
     */
    ngOnInit(): void {
        this._authService.profile().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: any) => {
            this.user = response;
            this._changeDetectorRef.markForCheck();
        });
        // Subscribe to user changes
        this._userService.user$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((user: UserResource) => {
                this.user = user;
                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void {
        // Return if user is not available
        if (!this.user) {
            return;
        }
        /**
         // Update the user
         this._userService.update({
            ...this.user,
            status
        }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
         */
    }
    /**
     * Sign out
     */
    signOut(): void {
        this._router.navigate(['/sign-out']);
    }
    userProfile(): void
    {
        this._router.navigate(['/profile']);
    }
}